import { render, staticRenderFns } from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=template&id=5426fdf6"
import script from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=script&lang=js"
export * from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=script&lang=js"
import style0 from "./LernzielvereinbarungBewertungFoerderunterrichtModal.vue?vue&type=style&index=0&id=5426fdf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports